<template>
  <div class="create-organization">
    <div v-if="busy" class="overlay">
      <loader-inline />
    </div>
    <div v-if="showAdd" class="edit-container">
      <input
        ref="input"
        v-model="name"
        autofocus
        type="text"
        :placeholder="$t('form.placeholder.write_here')"
        @keyup.enter="create"
      />
      <a
        v-tooltip="confirmTip"
        role="button"
        class="text-success"
        :class="{ 'btn-disabled': !nameIsValid }"
        @click.prevent="create"
      >
        <i class="fas fa-check"></i>
      </a>
      <a
        v-tooltip="$t('form.button.cancel')"
        role="button"
        class="text-danger"
        @click.prevent="toggleAdd"
      >
        <i class="fas fa-times"></i>
      </a>
    </div>
    <a v-else class="add" @click="toggleAdd">
      {{ $t("form.button.add") }}
    </a>
    <div v-if="showAdd && isUsedName" class="text-danger" role="button">
      {{ $t("form.validation_messages.used", { label: "Name" }) }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoaderInline from "../../loader-inline";
import { clearCase } from "../../../helpers/case";

export default {
	name: 'OrganizationCreate',

  components: {
    LoaderInline,
  },

  props: {
    organizations: {
      type: Array,
      required: true,
    },
    tagId: {
      type: Number
    }
  },

  data: function () {
    return {
      showAdd: false,
      busy: false,
      name: "",
    };
  },

  computed: {
    isUsedName() {
      return this.organizations.find((item) => {
        return clearCase(item.name) === clearCase(this.name);
      });
    },
    nameIsValid() {
      return clearCase(this.name) && !this.isUsedName;
    },
    confirmTip() {
      if (!clearCase(this.name)) return this.$t("form.validation_messages.required", { label: "Name" });

      if (this.isUsedName) return this.$t("form.validation_messages.used", { label: "Name" });

      return this.$t('form.button.confirm');
    }
  },

  updated: function () {
    this.$nextTick(
      function () {
        if (this.$refs && this.$refs.input) {
          this.$refs.input.focus();
        }
      }
    );
  },

  methods: {
    ...mapActions("organizations", ["createOrganization"]),
    toggleAdd: function () {
      this.name = "";
      this.showAdd = !this.showAdd;
    },
    create: function () {
      if (this.nameIsValid) {
        this.busy = true;

        this.createOrganization({
          projectId: this.$route.params.project_uid,
          organization: {
            name: this.name,
            parent_tag_id: this.tagId
          },
        })
          .then(() => {
            this.toggleAdd();
          })
          .finally( () => {
            this.name = '';
            this.busy = false;
          });
      }
    },
    cancel: function () {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss">
$background: #f5f5f5;

.create-organization {
  position: relative;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $background;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .edit-container {
    display: flex;
    height: 28px;

    input {
      outline: 0;
      flex: 1;
      border: 0;
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;
      margin-right: 0px;
    }

    a {
      cursor: pointer;
      line-height: 27px;
      border-bottom: 1px solid #ccc;
      display: inline-block;
      width: 18px;
      text-align: center;
      margin-bottom: 0px;
      margin-right: 0px;
    }
  }

  .add {
    line-height: 32px;
    display: block;
    cursor: pointer;
  }
}
</style>